import React from "react";
import { useTranslation } from "react-i18next";
import { useAISVessels } from "~/pages/ais-vessel-page/hooks/useAISVessels";
import { useAlarmIndicatorStore } from "../useAlarmIndicatorStore";

const alarmKey = "ais-vessels";

export const useAisVesselAlarmUpdate = () => {
  const { updateAlarm } = useAlarmIndicatorStore();
  const { someVesselHasAlarm } = useAISVessels();
  const { t } = useTranslation();
  React.useEffect(() => {
    updateAlarm(
      alarmKey,
      !someVesselHasAlarm,
      t("ais-routers:routerHasAlarms"),
    );
  }, [someVesselHasAlarm, t, updateAlarm]);
  // updateAlarm(alarmKey, !!hasAlarm);
};
